import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../lib/firebase";
import { useAuth } from "../lib/auth";
import { api, callableErrorMessage } from "../lib/api";
import { clearPendingJoin, readPendingJoin } from "../lib/pendingJoin";

export function Onboarding() {
  const { user, refreshClaims } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const joinTarget = params.get("join") ?? readPendingJoin();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!joinTarget) return;
    let cancelled = false;
    (async () => {
      setBusy(true);
      setError(null);
      try {
        await api.joinTenant({ tenantId: joinTarget });
        clearPendingJoin();
        await refreshClaims();
        if (!cancelled) nav("/", { replace: true });
      } catch (err) {
        if (!cancelled) {
          setError(callableErrorMessage(err));
          clearPendingJoin();
        }
      } finally {
        if (!cancelled) setBusy(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [joinTarget]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="min-h-dvh bg-cream">
      <div className="container-page flex flex-col gap-6">
        <header>
          <p className="text-xs uppercase tracking-[0.2em] text-leaf-600">Fideliza</p>
          <h1 className="mt-1 font-display text-2xl font-semibold text-leaf-950">
            Conecta tu cuenta a un comercio
          </h1>
        </header>

        <section className="card flex flex-col gap-3">
          <p className="text-sm text-leaf-800">
            Tu sesión <span className="font-semibold">{user?.email}</span> todavía no está asociada
            a ningún comercio.
          </p>
          <p className="text-sm text-leaf-700">
            Escanea el código QR de tu local favorito para empezar a juntar tickets. Si ya
            escaneaste uno, espera un momento mientras te conectamos.
          </p>
          {busy && (
            <p className="rounded-2xl bg-leaf-50 px-4 py-3 text-sm text-leaf-800">
              Conectando…
            </p>
          )}
          {error && (
            <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}
        </section>

        <button onClick={() => signOut(auth)} className="btn-ghost self-start text-sm">
          Cerrar sesión
        </button>
      </div>
    </main>
  );
}
